import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Panchayats from "@/pages/Panchayats";
import Properties from "@/pages/Properties";
import Tax from "@/pages/Tax";
import TaxReceipt from "@/pages/TaxReceipt";
import Certificates from "@/pages/Certificates";
import CertificatePrint from "@/pages/CertificatePrint";
import Grievances from "@/pages/Grievances";
import GrievanceNew, { GrievanceTrack } from "@/pages/GrievancePublic";
import Approvals from "@/pages/Approvals";
import PropertiesMap from "@/pages/PropertiesMap";
import Reports from "@/pages/Reports";
import CashBook from "@/pages/CashBook";
import Planning from "@/pages/Planning";
import AssetsAll from "@/pages/AssetsAll";
import Stakeholders from "@/pages/Stakeholders";
import GovernancePage from "@/pages/GovernancePage";
import Accounting from "@/pages/Accounting";
import Audit from "@/pages/Audit";
import TaxEngine from "@/pages/TaxEngine";
import OtherTax from "@/pages/OtherTax";
import Notices from "@/pages/Notices";
import VillageAreas from "@/pages/VillageAreas";
import UsersPage from "@/pages/Users";
import Settings from "@/pages/Settings";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/grievance/new" element={<GrievanceNew />} />
            <Route path="/track" element={<GrievanceTrack />} />

            {/* Authenticated */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/panchayats" element={<ProtectedRoute><Panchayats /></ProtectedRoute>} />
            <Route path="/properties" element={<ProtectedRoute><Properties /></ProtectedRoute>} />
            <Route path="/tax" element={<ProtectedRoute><Tax /></ProtectedRoute>} />
            <Route path="/tax/receipts/:id" element={<ProtectedRoute><TaxReceipt /></ProtectedRoute>} />
            <Route path="/certificates" element={<ProtectedRoute><Certificates /></ProtectedRoute>} />
            <Route path="/certificates/print/:id" element={<ProtectedRoute><CertificatePrint /></ProtectedRoute>} />
            <Route path="/grievances" element={<ProtectedRoute><Grievances /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
            <Route path="/map" element={<ProtectedRoute><PropertiesMap /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/cashbook" element={<ProtectedRoute><CashBook /></ProtectedRoute>} />
            <Route path="/planning" element={<ProtectedRoute><Planning /></ProtectedRoute>} />
            <Route path="/assets" element={<ProtectedRoute><AssetsAll /></ProtectedRoute>} />
            <Route path="/stakeholders" element={<ProtectedRoute><Stakeholders /></ProtectedRoute>} />
            <Route path="/governance" element={<ProtectedRoute><GovernancePage /></ProtectedRoute>} />
            <Route path="/accounting" element={<ProtectedRoute><Accounting /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute><Audit /></ProtectedRoute>} />
            <Route path="/tax-engine" element={<ProtectedRoute><TaxEngine /></ProtectedRoute>} />
            <Route path="/other-tax" element={<ProtectedRoute><OtherTax /></ProtectedRoute>} />
            <Route path="/notices" element={<ProtectedRoute><Notices /></ProtectedRoute>} />
            <Route path="/village-areas" element={<ProtectedRoute><VillageAreas /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
